import { Controller } from "@hotwired/stimulus";

/**
 * Controller for managing ChatKit panel state.
 * Works in conjunction with Alpine.js to handle panel state.
 * CSS handles layout adjustments automatically via :has() selector.
 * Ensures data attribute is set correctly after Turbo navigations.
 */
export default class extends Controller {
  connect() {
    // Wait for Alpine.js to initialize, then sync the data attribute
    // This ensures the attribute is set even after Turbo frame reloads
    this.syncAttribute();

    // Listen for Alpine.js initialization
    if (typeof globalThis.Alpine !== 'undefined') {
      // Use nextTick to ensure Alpine has processed x-data
      globalThis.Alpine.nextTick(() => {
        this.syncAttribute();
      });
    }

    // Also listen for state changes
    this.stateChangeHandler = () => {
      this.syncAttribute();
    };
    globalThis.addEventListener('chatkit-panel-state-change', this.stateChangeHandler);
  }

  disconnect() {
    if (this.stateChangeHandler) {
      globalThis.removeEventListener('chatkit-panel-state-change', this.stateChangeHandler);
    }
  }

  syncAttribute() {
    // Check if Alpine.js has set the attribute
    // If not, check sessionStorage for persisted state (tab-specific)
    if (!this.element.dataset.chatkitOpen) {
      try {
        // Check Alpine persist storage (it uses a specific format)
        const persisted = sessionStorage.getItem('chatkitPanel.open');
        if (persisted) {
          // Alpine persist stores values as JSON strings
          const value = JSON.parse(persisted);
          if (value === true) {
            this.element.dataset.chatkitOpen = 'true';
          }
        }
      } catch {
        // sessionStorage might not be available
      }
    }
  }
}
